import type { JSX } from 'react';
import clsx from 'clsx';

import type { StatusChip } from '~/hooks/useProjectFiltering';
import { CHIP_LABELS, FILTER_CHIPS } from '~/hooks/useProjectFiltering';

interface ProjectStatusChipsProps {
  clearChips: () => void;
  selectedChips: StatusChip[];
  toggleChip: (chip: StatusChip) => void;
}

export function ProjectStatusChips({
  clearChips,
  selectedChips,
  toggleChip,
}: ProjectStatusChipsProps): JSX.Element {
  return (
    <div
      className="flex items-center gap-2 px-4 py-2 shrink-0"
      role="group"
      aria-label="Filter projects by status"
    >
      {FILTER_CHIPS.map(chip => (
        <button
          key={chip}
          aria-pressed={selectedChips.includes(chip)}
          className={clsx(
            'rounded-full px-3 py-1 text-sm font-medium transition-colors border',
            selectedChips.includes(chip)
              ? 'bg-white/15 text-primary-200 border-primary-200/30'
              : 'text-muted border-default hover:text-foreground hover:bg-surface-elevated',
          )}
          onClick={() => toggleChip(chip)}
        >
          {CHIP_LABELS[chip]}
        </button>
      ))}
      {selectedChips.length > 0 && (
        <button
          className="ml-auto text-sm text-muted hover:text-foreground transition-colors"
          onClick={clearChips}
        >
          Clear
        </button>
      )}
    </div>
  );
}
